import { __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var Invoice = function (props) {
  return React__default.createElement("svg", __assign({
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M7.99992 2.6665C6.53931 2.6665 5.33325 3.87256 5.33325 5.33317V26.6665C5.33325 28.1271 6.53931 29.3332 7.99992 29.3332H23.9999C25.4573 29.3332 26.6666 28.1239 26.6666 26.6665V10.6665L18.6666 2.6665H7.99992ZM7.99992 5.33317H17.3333V11.9998H23.9999V26.6665H7.99992V5.33317Z",
    fill: "currentColor"
  }), React__default.createElement("path", {
    d: "M13.0371 13.6251V12.2964H15.4075V13.6992C16.1604 14.0437 17.3334 14.9352 17.3334 17.0371H15.1135C15.1135 15.5639 14.4293 15.1297 14.1413 15.1297C13.9837 15.1297 13.2547 15.1685 13.2547 16.3774C13.2559 18.4882 17.3172 17.8304 17.3172 21.2686C17.3172 23.0306 16.2054 23.7071 15.4075 23.9746V25.3334H13.0371V24.0418C12.2252 23.8222 10.6667 23.0974 10.6667 20.5927H12.8867C12.8867 22.425 13.9212 22.5094 14.0788 22.5094C14.2518 22.5094 15.0973 22.4807 15.0973 21.2825C15.0973 18.8908 11.0348 19.9521 11.0348 16.3681C11.0348 14.5591 12.2407 13.8788 13.0371 13.6251Z",
    fill: "currentColor"
  }));
};
export { Invoice as default };
//# sourceMappingURL=Invoice.js.map
